import { EntityArchivedIcon } from '../../EntityArchivedIcon'
import { EntityProfileHeaderTextButton } from '../../EntityProfileHeaderTextButton'

import * as styles from '../EntityProfileHeaderText.module.css'

function EntityProfileHeaderTextTail({
  EditButton = EntityProfileHeaderTextButton,
  additionalIcons,
  editButtonClassName,
  editButtonQaName,
  isArchived,
  isMeasure = false,
  tailRef,
  onClickEditButton,
}) {
  return (
    <span className={styles.tail} ref={tailRef}>
      {additionalIcons}
      {isArchived ? (
        <EntityArchivedIcon containerClassName={styles.archivedIcon} />
      ) : null}
      {EditButton ? (
        <EditButton
          className={editButtonClassName}
          isMeasure={isMeasure}
          qaName={editButtonQaName}
          onClick={onClickEditButton}
        />
      ) : null}
    </span>
  )
}

export default EntityProfileHeaderTextTail
